export default __webpack_public_path__ + "static/apotekerforeningen_Type_2_Diabetes_Sept_2020-c63312ee4218513ffaa7b6e590e6e28b.pdf";